/* Minomake "Track my order" page: asks our tracking server (17TRACK behind it) and draws the result.
   Links from emails can prefill the form: ?tn=TRACKINGNUMBER (searches right away) or ?order=1001. */
(function(){
  var cfgEl = document.getElementById('trk-config');
  var form = document.getElementById('trk-form');
  if (!cfgEl || !form) return;
  var C = JSON.parse(cfgEl.textContent), T = C.t;
  var out = document.getElementById('trk-result');
  var msg = document.getElementById('trk-msg');
  var go = form.querySelector('.trk-go-label');
  var mode = 'order', busy = false;

  /* ---------- Small helpers ---------- */
  function $(id){ return document.getElementById(id); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function icon(name, size){ return '<svg width="' + (size || 22) + '" height="' + (size || 22) + '" aria-hidden="true"><use href="#i-' + name + '"/></svg>'; }
  // Carriers often shout: "MEMPHIS TN DISTRIBUTION CENTER" → "Memphis TN Distribution Center"
  function calm(s){
    s = String(s || '');
    if (s !== s.toUpperCase() || !/[A-Z]{3}/.test(s)) return s;
    return s.toLowerCase().replace(/\b([a-z])([a-z]*)/g, function(w, a, b){ return w.length <= 2 ? w.toUpperCase() : a.toUpperCase() + b; });
  }
  // Event times are kept in the carrier's local time (as printed on the label scan), not converted
  function parts(iso){
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/.exec(iso || '');
    return m ? new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0))) : null;
  }
  function fmtDate(iso, long){
    var d = parts(iso); if (!d) return '';
    return d.toLocaleDateString(C.locale, {timeZone: 'UTC', weekday: long ? 'short' : undefined, month: 'short', day: 'numeric'});
  }
  function fmtTime(iso){
    var d = parts(iso); if (!d || !/T\d{2}:\d{2}/.test(iso)) return '';
    return d.toLocaleTimeString(C.locale, {timeZone: 'UTC', hour: 'numeric', minute: '2-digit'});
  }

  /* ---------- Status → page state ---------- */
  // Steps: 0 Ordered, 1 Shipped, 2 On its way, 3 Out for delivery, 4 Delivered
  var STATE = {
    NotFound: ['ready', 1], InfoReceived: ['ready', 1], InTransit: ['transit', 2], Expired: ['transit', 2],
    Exception: ['issue', 2], DeliveryFailure: ['issue', 3], AvailableForPickup: ['pickup', 3],
    OutForDelivery: ['out', 3], Delivered: ['delivered', 4]
  };
  var BADGE = {preparing: 'gift', ready: 'gift', transit: 'truck', out: 'truck', pickup: 'hand', delivered: 'check', issue: 'heart'};

  function stepDates(s, placed){
    var m = s.milestones || {};
    return [placed, m.PickedUp || m.InfoReceived, m.Departure || m.Arrival, m.OutForDelivery || m.AvailableForPickup, m.Delivered];
  }

  function card(s, i, n, placed){
    var st = s ? (STATE[s.status] || STATE.NotFound) : ['preparing', 1];
    var key = st[0], now = st[1], txt = T.states[key] || ['', ''];
    var dates = s ? stepDates(s, placed) : [placed];
    var h = '<article class="trk-card trk-ship trk--' + key + '">';
    h += '<header class="trk-status"><span class="trk-badge">' + icon(BADGE[key], 28) + '</span><div>';
    var kick = [];
    if (n > 1) kick.push(T.package.replace('[i]', i + 1).replace('[n]', n));
    if (s && s.carrier && s.carrier.name) kick.push(s.carrier.name);
    if (kick.length) h += '<span class="trk-kicker">' + esc(kick.join(' · ')) + '</span>';
    h += '<h2>' + esc(txt[0]) + '</h2><p>' + esc(txt[1]) + '</p></div></header>';

    if (s && s.eta && key !== 'delivered') {
      var a = fmtDate(s.eta.from || s.eta.to, true), b = fmtDate(s.eta.to, true);
      h += '<div class="trk-eta">' + icon('truck', 18) + '<span>' + esc(T.eta) + '</span><b>' + esc(a && b && a !== b ? a + ' – ' + b : (a || b)) + '</b></div>';
    }

    h += '<ol class="trk-steps">';
    T.steps.forEach(function(label, k){
      var cls = k < now || key === 'delivered' ? 'is-done' : (k === now ? 'is-now' : '');
      if (key === 'issue' && k === now) cls += ' is-alert';
      var d = dates[k] ? fmtDate(dates[k]) : '';
      h += '<li class="' + cls + '"' + (k === now && key !== 'delivered' ? ' aria-current="step"' : '') + '><span class="dot">' + (cls.indexOf('is-done') >= 0 ? icon('check', 14) : '') + '</span><span class="lbl">' + esc(label) + '</span>' + (d && cls ? '<small>' + esc(d) + '</small>' : '') + '</li>';
    });
    h += '</ol>';

    if (s) {
      h += '<div class="trk-meta"><span>' + esc(T.number) + ' <b>' + esc(s.number) + '</b></span>';
      h += '<button type="button" class="trk-copy" data-copy="' + esc(s.number) + '">' + esc(T.copy) + '</button>';
      if (s.link) h += '<a class="trk-carrier" href="' + esc(s.link) + '" target="_blank" rel="noopener">' + esc(T.carrierLink.replace('[carrier]', (s.carrier && s.carrier.name) || 'carrier')) + '</a>';
      h += '</div>';
      h += '<div class="trk-history"><h3>' + esc(T.history) + '</h3>';
      if (s.events && s.events.length) {
        h += '<ol class="trk-events">';
        s.events.forEach(function(e, k){
          var when = [fmtDate(e.time, true), fmtTime(e.time)].filter(Boolean).join(', ');
          var text = e.step ? (T.gen[e.step] || T.gen.transit) : e.text; // e.step: scan before reaching the country, shown without places
          h += '<li' + (k === 0 ? ' class="is-latest"' : '') + '><span class="ev-dot"></span><b>' + esc(text) + '</b><span>' + esc([calm(e.where), when].filter(Boolean).join(' · ')) + '</span></li>';
        });
        h += '</ol>';
      } else {
        h += '<p class="trk-none">' + esc(T.noEvents) + '</p>';
      }
      h += '</div>';
    }
    return h + '</article>';
  }

  function show(data, quiet){
    var list = data.shipments || [];
    var html = list.length ? list.map(function(s, i){ return card(s, i, list.length, data.placed_at); }).join('') : card(null, 0, 1, data.placed_at);
    out.innerHTML = html;
    if (quiet) return;
    out.focus({preventScroll: true});
    var top = out.getBoundingClientRect().top + window.pageYOffset - 90;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({top: top, behavior: reduce ? 'auto' : 'smooth'});
  }

  /* ---------- Form ---------- */
  function setMode(m){
    mode = m;
    Array.prototype.forEach.call(form.querySelectorAll('.trk-mode'), function(el){ el.hidden = el.getAttribute('data-mode') !== m; });
    $('trk-switch').textContent = m === 'order' ? T.toNumber : T.toOrder;
    say('');
  }
  function say(text){ msg.textContent = text; msg.hidden = !text; }
  function setBusy(on){ busy = on; form.classList.toggle('is-busy', on); go.textContent = on ? T.loading : T.button; }

  function ask(body){
    if (demoKey()) return new Promise(function(res){ setTimeout(function(){ res(demo(demoKey())); }, 500); });
    if (!C.api) return Promise.reject(new Error('config'));
    return fetch(C.api, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)})
      .then(function(r){ return r.json().catch(function(){ return {}; }).then(function(j){ if (!r.ok) { var e = new Error(j.error || 'error'); e.code = r.status; throw e; } return j; }); });
  }

  function search(quiet){
    if (busy) return;
    var body;
    if (mode === 'order') {
      var o = $('trk-order').value.trim(), e = $('trk-email').value.trim();
      if (!o || !e) { say(T.missingOrder); (o ? $('trk-email') : $('trk-order')).focus(); return; }
      body = {order: o, email: e};
    } else {
      var n = $('trk-number').value.trim();
      if (!n) { say(T.missingNumber); $('trk-number').focus(); return; }
      body = {number: n};
    }
    say(''); setBusy(true);
    ask(body).then(function(data){ setBusy(false); show(data, quiet); })
      .catch(function(err){ setBusy(false); out.innerHTML = ''; say(err && (err.code === 404 || err.code === 400) ? T.notFound : T.error); });
  }

  form.addEventListener('submit', function(e){ e.preventDefault(); search(); });
  $('trk-switch').addEventListener('click', function(){ setMode(mode === 'order' ? 'number' : 'order'); (mode === 'order' ? $('trk-order') : $('trk-number')).focus(); });
  out.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-copy]'); if (!b) return;
    var done = function(){ b.textContent = T.copied; setTimeout(function(){ b.textContent = T.copy; }, 1600); };
    if (navigator.clipboard) navigator.clipboard.writeText(b.getAttribute('data-copy')).then(done, function(){});
  });

  /* ---------- Example data (theme editor, or ?demo=…) ---------- */
  function demoKey(){ var m = /[?&]demo=(\w+)/.exec(location.search); return m ? m[1] : (C.demo || ''); }
  function demo(k){
    var day = function(n, h){ var d = new Date(Date.now() + n * 864e5); return d.toISOString().slice(0, 10) + 'T' + (h || '10:00') + ':00-05:00'; };
    var placed = day(-4, '09:12');
    if (k === 'preparing') return {placed_at: placed, shipments: []};
    var status = {ready: 'InfoReceived', transit: 'InTransit', out: 'OutForDelivery', pickup: 'AvailableForPickup', delivered: 'Delivered', issue: 'Exception'}[k] || 'InTransit';
    var ev = [
      {time: day(-3).slice(0, 10), step: 'info'},
      {time: day(-2).slice(0, 10), step: 'pickup'},
      {time: day(-1).slice(0, 10), step: 'transit'},
      {time: day(-1, '06:05'), text: 'Arrived at regional facility', where: 'MEMPHIS TN NETWORK DISTRIBUTION CENTER'}
    ];
    if (k === 'ready') ev = ev.slice(0, 1);
    if (k === 'out' || k === 'delivered') ev.push({time: day(0, '07:48'), text: 'Out for delivery', where: 'BROOKLYN, NY 11201'});
    if (k === 'pickup') ev.push({time: day(0, '11:20'), text: 'Available for pickup at the post office', where: 'BROOKLYN, NY 11201'});
    if (k === 'delivered') ev.push({time: day(0, '14:32'), text: 'Delivered, front door', where: 'BROOKLYN, NY 11201'});
    if (k === 'issue') ev.push({time: day(0, '08:10'), text: 'Delivery delayed by weather', where: 'NEWARK, NJ 07114'});
    return {placed_at: placed, shipments: [{
      number: '9400111202555842736190', status: status, carrier: {name: k === 'ready' ? '' : 'USPS'}, link: '',
      eta: {from: day(1), to: day(2)},
      milestones: {InfoReceived: day(-3, '16:40'), PickedUp: k === 'ready' ? null : day(-2, '18:05'), Departure: k === 'ready' ? null : day(-1, '06:05'), OutForDelivery: k === 'out' || k === 'delivered' ? day(0, '07:48') : null, AvailableForPickup: k === 'pickup' ? day(0, '11:20') : null, Delivered: k === 'delivered' ? day(0, '14:32') : null},
      events: ev.reverse()
    }]};
  }

  /* ---------- Start ---------- */
  var q = new URLSearchParams(location.search);
  if (q.get('tn')) { setMode('number'); $('trk-number').value = q.get('tn'); search(); }
  else if (q.get('order')) { $('trk-order').value = q.get('order'); }
  if (demoKey()) { if (!q.get('tn')) { $('trk-order').value = '#1001'; $('trk-email').value = 'you@example.com'; search(true); } }
})();
